<template>
  <v-snackbar v-show="showNotif" top v-model="showNotif" multi-line :color="type" transition="ease">
    {{ msg }}
    <v-btn text @click="close">Close</v-btn>
  </v-snackbar>
</template>
<script>
export default {
  data() { return { showNotif: false } },
  methods: {
    close() { this.$store.dispatch('nCloseMessage', false) }
  },
  computed: {
    show() { return this.$store.getters.getNotification.show },
    type() { return this.$store.getters.getNotification.type },
    msg() { return this.$store.getters.getNotification.msg }
  },
  watch: { show(value) { this.showNotif = value } }

}
</script>
